import { render } from "./proposition-select-row.vue?vue&type=template&id=96746064"
import script from "./proposition-select-row.vue?vue&type=script&lang=js"
export * from "./proposition-select-row.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__